import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  Card
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import LanguageTabs from '../../propinfo/components/LanguageTabs/LanguageTabs';
import fieldsListData from '../../../../../data/visitorFieldsList.json';
import ReactQuill from 'react-quill';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
];
export function InactivePopUpFormSettings({
  visible,
  toggle,
  formLabel,
  submit,
  popupData,
  number,
  defaultMessage,
  defaultSeconds,
  minTime,
  popupLanguage,
  locale,
  handleLanguageSubmit,
  integrationLanguages
}) {
  // console.log(nudgeData);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLang, setSelectedLang] = useState(locale);
  const [updateInactivePopupData, setupdateInactivePopupData] = useState({});
  const [fieldList, setFieldList] = useState([]);
  const [errorData, setErrorData] = useState('');
  const [languagePopUpData, setLangaugePopUpData] = useState([]);

  useEffect(() => {
    // console.log(popupData);
    if (popupData !== null && popupData !== undefined) {
      setupdateInactivePopupData({
        ...updateInactivePopupData,
        message: popupData.message,
        seconds: popupData.seconds,
        enabled: popupData.enabled,
        number: number,
        title: popupData.title,
        subTitle: popupData.subTitle,
        buttonText: popupData.buttonText,
        fields: popupData.fields,
        checkboxText: popupData.checkboxText,
      });
      let check = false;
      if (popupData.fields !== null) {
        popupData.fields.forEach((r) => {
          if (r.field === 'Name') {
            check = true;
          }
        });
      }
      let dataValues = fieldsListData.data.map((elem) => {
        elem.on_off = false;
        elem.required = false;
        elem.isEnabled = true;
        if (popupData.fields !== null) {
          popupData.fields.forEach((r) => {
            if (r.field === elem.id) {
              if (r.placeHolder === null) { elem.placeHolder = elem?.name; }
              else { elem.placeHolder = r.placeHolder; }
              if (r.mandatory !== null && r.mandatory) {
                elem.on_off = true;
              } else {
                elem.on_off = false;
              }
              elem.required = true;
            }
            if (check && (elem.id === 'LastName' || elem.id === 'FirstName')) {
              elem.isEnabled = false;
            }
            if (!check && elem.id === 'Name') {
              elem.isEnabled = false;
            }
          });
        }
        return elem;
      });
      setFieldList(dataValues);
    } else {
      setupdateInactivePopupData({
        ...updateInactivePopupData,
        message: defaultMessage,
        seconds: defaultSeconds,
        enabled: false,
        number: number,
        title: 'Welcome to Hotel',
        buttonText: 'Start Conversation',
        subTitle:
          'Please leave your contact details to make sure we can get back in case you still have unanswered questions',
        fields: [],
        checkboxText:
          'I want to receive offers or promotions from the hotel by email or text messages.',
      });
      setFieldList(
        fieldsListData.data.map((elem) => {
          elem.on_off = false;
          elem.isEnabled = true;
          elem.required = false;
          elem.placeHolder = elem?.name;
          return elem;
        })
      );
    }

    if (popupLanguage !== null && popupLanguage.length > 0) {
      setLangaugePopUpData(popupLanguage);
    }
  }, [popupLanguage]);
  const LoadPopupByLanguage = (lang) => {
    setIsLoading(true);
    if (lang === "en" && popupData !== null && popupData !== undefined) {
      setupdateInactivePopupData({
        ...updateInactivePopupData,
        message: popupData.message,
        seconds: popupData.seconds,
        enabled: popupData.enabled,
        number: number,
        title: popupData.title,
        subTitle: popupData.subTitle,
        buttonText: popupData.buttonText,
        fields: popupData.fields,
        checkboxText: popupData.checkboxText,
      });
      let check = false;
      if (popupData.fields !== null) {
        popupData.fields.forEach((r) => {
          if (r.field === 'Name') {
            check = true;
          }
        });
      }
      let dataValues = fieldsListData.data.map((elem) => {
        elem.on_off = false;
        elem.required = false;
        elem.isEnabled = true;
        if (popupData.fields !== null) {
          popupData.fields.forEach((r) => {
            if (r.field === elem.id) {
              if (r.placeHolder === null) { elem.placeHolder = elem?.name; }
              else { elem.placeHolder = r.placeHolder; }
              if (r.mandatory !== null && r.mandatory) {
                elem.on_off = true;
              } else {
                elem.on_off = false;
              }
              elem.required = true;
            }
            if (check && (elem.id === 'LastName' || elem.id === 'FirstName')) {
              elem.isEnabled = false;
            }
            if (!check && elem.id === 'Name') {
              elem.isEnabled = false;
            }
          });
        }
        return elem;
      });
      setFieldList(dataValues);

      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
    else {
      console.log(203, languagePopUpData);
      var langpopup = languagePopUpData.filter(x => x.languageCode === lang);
      console.log(204, langpopup);
      if (langpopup !== undefined && langpopup !== null && langpopup.length > 0) {
        var popup = langpopup[0];
        setupdateInactivePopupData({
          ...updateInactivePopupData,
          message: popup.message,
          number: number,
          title: popup.title,
          subTitle: popup.subTitle,
          buttonText: popup.buttonText,
          fields: popup.fields,
          checkboxText: popup.checkboxText,
          languageCode: popup.languageCode
        });
        let check = false;
        popup.fields.forEach((r) => {
          if (r.field === 'Name') {
            check = true;
          }
        });
        let dataValues = fieldsListData.data.map((elem) => {
          elem.on_off = false;
          elem.required = false;
          elem.isEnabled = true;
          if (popup.fields !== null) {
            popup.fields.forEach((r) => {
              if (r.field === elem.id) {
                if (r.placeHolder === null) { elem.placeHolder = elem?.name; }
                else { elem.placeHolder = r.placeHolder }

                if (r.mandatory !== null && r.mandatory) {
                  elem.on_off = true;
                } else {
                  elem.on_off = false;
                }
                elem.required = true;
              }
              if (check && (elem.id === 'LastName' || elem.id === 'FirstName')) {
                elem.isEnabled = false;
              }
              if (!check && elem.id === 'Name') {
                elem.isEnabled = false;
              }
            });
          }
          return elem;
        });
        setFieldList(dataValues);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
      else {
        setupdateInactivePopupData({
          ...updateInactivePopupData,
          message: defaultMessage,
          seconds: defaultSeconds,
          enabled: false,
          number: number,
          title: 'Welcome to Hotel',
          buttonText: 'Start Conversation',
          subTitle:
            'Please leave your contact details to make sure we can get back in case you still have unanswered questions',
          fields: [],
          checkboxText:
            'I want to receive offers or promotions from the hotel by email or text messages.',
          languageCode: lang

        });
        setFieldList(
          fieldsListData.data.map((elem) => {
            elem.on_off = false;
            elem.isEnabled = true;
            elem.required = false;
            elem.placeHolder = elem?.name;
            return elem;
          })
        );

        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    }
  }
  const handleChange = (e) => {
    setupdateInactivePopupData({
      ...updateInactivePopupData,
      [e.target.name]: e.target.value,
    });
  };
  const handleCheckChange = (checked) => {
    setupdateInactivePopupData((prev) => ({
      ...prev,
      enabled: checked,
    }));
  };

  const handleFieldChange = (e) => {
    const values = fieldList.map((elem) => {
      if (elem?.name === e.name) {
        if (elem.on_off) {
          elem.on_off = false;
        } else if (!elem.on_off) {
          elem.on_off = true;
        }
      }
      return {
        ...elem,
      };
    });
    setFieldList(values);
    let fieldArr = [];
    values.map((m) => {
      if (m.required === true && m.isEnabled) {
        if (m.on_off == true) {
          fieldArr.push({
            field: m.id,
            mandatory: true,
            placeHolder: m.placeHolder
          });
        } else {
          fieldArr.push({
            field: m.id,
            mandatory: false,
            placeHolder: m.placeHolder
          });
        }
      }
    });

    setupdateInactivePopupData({
      ...updateInactivePopupData,
      fields: fieldArr,
    });
  };
  const handleElementCheckChange = (id, enabled, checked) => {
    const values = fieldList.map((f) => {
      if (f.id === id) {
        if (f.required === true) {
          f.required = false;
        } else {
          f.required = true;
        }
      }
      if (id === 'Name' && (f.id === 'FirstName' || f.id === 'LastName')) {
        if (checked) {
          f.isEnabled = true;
        } else {
          f.isEnabled = false;
          f.required = false;
        }
      } else if ((id === 'FirstName' || id === 'LastName') && f.id === 'Name') {
        if (checked) {
          if (id === 'FirstName') {
            fieldList.map((m) => {
              if (m.id === 'LastName' && !m.required) {
                f.isEnabled = true;
              }
            });
          }
          if (id === 'LastName') {
            fieldList.map((m) => {
              if (m.id === 'FirstName' && !m.required) {
                f.isEnabled = true;
              }
            });
          }
        } else {
          f.isEnabled = false;
          f.required = false;
        }
      }
      return { ...f };
    });
    setFieldList(values);
    let fieldArr = [];
    values.map((m) => {
      if (m.required === true && m.isEnabled) {
        if (m.on_off == true) {
          fieldArr.push({
            field: m.id,
            mandatory: true,
            placeHolder: m.placeHolder
          });
        } else {
          fieldArr.push({
            field: m.id,
            mandatory: false,
            placeHolder: m.placeHolder
          });
        }
      }
    });

    setupdateInactivePopupData({
      ...updateInactivePopupData,
      fields: fieldArr,
    });
  };
  const handleSubTitleChange = (source, data) => {
    setupdateInactivePopupData({
      ...updateInactivePopupData,
      subTitle: data,
    });
  };
  const handleChangePlaceholder = (event, index) => {
    const values = [...fieldList];
    if (event.target.name === 'placeHolder') {
      values[index].placeHolder = event.target.value;
    }
    setFieldList(values);
    let fieldArr = [];
    values.map((m) => {
      if (m.required === true && m.isEnabled) {
        if (m.on_off == true) {
          fieldArr.push({
            field: m.id,
            mandatory: true,
            placeHolder: m.placeHolder
          });
        } else {
          fieldArr.push({
            field: m.id,
            mandatory: false,
            placeHolder: m.placeHolder
          });
        }
      }
    });
    setupdateInactivePopupData({
      ...updateInactivePopupData,
      fields: fieldArr,
    });
  }
  const handleSubmit = () => {
    if (selectedLang === "en") {
      if (updateInactivePopupData.seconds < minTime) {
        setErrorData('The seconds should be greater than or equal to ' + minTime);
      } else {
        submit(updateInactivePopupData);
      }
    }
    else {
      handleLanguageSubmit(updateInactivePopupData);
    }
  };

  const SwitchLanguage = (e) => {
    setupdateInactivePopupData(null);
    setFieldList([]);
    LoadPopupByLanguage(e);
    setSelectedLang(e);
  }
  const styles = `
  .custom-quill .ql-toolbar.ql-snow {
    padding: 0px !important;
  }
  .custom-quill .ql-editor {
    padding: 6px 12px !important;
  }
  .custom-quill .ql-editor p {
    font-size: 12px !important;
  }
`;

  return (
    <Fragment>
      {updateInactivePopupData !== null && (
        <Modal isOpen={visible} toggle={toggle} size="lg" backdrop="static">
          <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
          {
            <ModalBody>
              <Row className="d-block align-items-center">
                {/* <pre>{JSON.stringify(updateEyeCatcherNudgesData, null, 2)}</pre> */}
                <Card className="mx-4 mb-4">
                  <Colxx xxs="12" className="py-3">
                    <div className="">
                      <Colxx sm={12}>
                        <div className="d-flex mb-3">
                          <Label><b>Enable</b></Label>
                          <Switch
                            className="agentswitch custom-switch-primary custom-switch-small ml-3"
                            id="enableSwitch"
                            name="enabled"
                            checked={updateInactivePopupData.enabled}
                            onChange={handleCheckChange}
                          />
                        </div>
                      </Colxx>
                      <Colxx sm={5} className="mt-2">
                        <div className="d-flex align-items-center">
                          <Label><b>Seconds</b></Label>
                          <Input
                            className="ml-2 mb-2"
                            type="number"
                            value={updateInactivePopupData.seconds}
                            onChange={handleChange}
                            name="seconds"
                            min={minTime}
                          />
                        </div>
                      </Colxx>
                    </div>
                  </Colxx>
                </Card>
                <Card className="mx-4">
                  <Colxx xxs="12" className="pt-3">
                    <div>
                      <Colxx sm={12}>
                        <Row>
                          <LanguageTabs
                            integrationLanguages={integrationLanguages}
                            selectedTab={selectedLang}
                            setLanguage={(e) => SwitchLanguage(e)}
                          ></LanguageTabs>
                        </Row>
                      </Colxx>
                      {isLoading ? (
                        <Colxx sm={12}>
                          <div className="loading" style={{ top: "calc(50% - 80px)", left: "calc(50% - 55px)" }} />
                        </Colxx>
                      ) : (
                        <Fragment>
                          <style>{styles}</style>
                          <Colxx sm={12} className="mb-3 mt-2">
                            <Label><b>Message</b></Label>
                            <Input
                              type="textarea"
                              value={updateInactivePopupData.message}
                              onChange={handleChange}
                              name="message"
                              style={{ height: "75px" }}
                            />
                          </Colxx>
                          <Colxx sm={12} className="mb-3 mt-2">
                            <Label><b>Title</b></Label>
                            <Input
                              type="text"
                              value={updateInactivePopupData.title}
                              onChange={handleChange}
                              name="title"
                            />
                          </Colxx>
                          <Colxx sm={12} className="mb-3 mt-2">
                            <Label><b>Sub Title</b></Label>
                            <ReactQuill
                              className="custom-quill"
                              theme="snow"
                              value={updateInactivePopupData.subTitle}
                              onChange={(content, delta, source) =>
                                handleSubTitleChange(source, content)
                              }
                              modules={quillModules}
                              formats={quillFormats}
                              name="subTitle"
                            />
                          </Colxx>
                          <Colxx sm={12} className="mb-3  mt-2">
                            <Label><b>Button Text</b></Label>
                            <Input
                              type="text"
                              value={updateInactivePopupData.buttonText}
                              onChange={handleChange}
                              name="buttonText"
                            />
                          </Colxx>
                          <Colxx sm={12} className="mb-3  mt-2">
                            <Label><b>Checkbox Text</b></Label>
                            <Input
                              type="text"
                              value={updateInactivePopupData.checkboxText}
                              onChange={handleChange}
                              name="checkboxText"
                            />
                          </Colxx>
                          <Colxx sm={12} className="">
                            <div className="d-flex">
                              <Colxx sm={3} className="d-flex mb-1 p-0">
                                <Label><b>Fields</b></Label>
                              </Colxx>
                              <Colxx sm={3} className="mb-1 text-center align-items-center d-flex justify-content-center">
                                <Label><b>Mandatory Field</b></Label>
                              </Colxx>
                              <Colxx sm={6} className="mb-1 px-1">
                                <Label><b>Place Holder</b></Label>
                              </Colxx>
                            </div>
                            {fieldList.map((elem, index) => (
                              <Fragment key={index}>
                                <div className="d-flex">
                                  <Colxx sm={3} className="d-flex mb-2 p-0">
                                    <CustomInput
                                      key={index}
                                      type="checkbox"
                                      value={elem?.name}
                                      id={elem?.name}
                                      onChange={() => {
                                        handleElementCheckChange(
                                          elem.id,
                                          elem.isEnabled,
                                          elem.required
                                        );
                                      }}
                                      checked={elem.required}
                                      disabled={!elem.isEnabled}
                                    ></CustomInput>
                                    <span className="mt-1">{elem?.name}</span>
                                  </Colxx>
                                  <Colxx sm={3} className="mb-2 text-center align-items-center d-flex justify-content-center">
                                    {elem.required ? (
                                      <Switch
                                        className="agentswitch custom-switch-primary custom-switch-small"
                                        onChange={() => {
                                          handleFieldChange(elem);
                                        }}
                                        checked={elem.on_off}
                                      />
                                    ) : null}
                                  </Colxx>
                                  <Colxx sm={6} className="mb-2 p-0">
                                    {elem.required ?
                                      <Input
                                        type="text"
                                        value={elem.placeHolder}
                                        onChange={(e) => handleChangePlaceholder(e, index)}
                                        name="placeHolder"
                                      /> : null
                                    }
                                  </Colxx>
                                </div>
                              </Fragment>
                            ))}
                          </Colxx>
                        </Fragment>)}
                      <Colxx sm={12}>
                        <Label style={{ color: 'red' }}>{errorData}</Label>
                      </Colxx>
                    </div>
                  </Colxx>
                </Card>
              </Row>
            </ModalBody>
          }
          <ModalFooter className="d-flex justify-content-center">
            <Button size="xs" color="primary" onClick={handleSubmit}>
              Update
            </Button>
            <Button size="xs" color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  );
}
